import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { breakpoints, RadioInputLabelProps } from '@cash-design-system/react'

import { RadioGroup, RadioGroupOption, RadioGroupProps } from '../RadioGroup'

const LabelWrapper = styled.div`
  width: 100%;
  text-align: center;
  flex: 1 0 0;
  ${({ theme }) => theme.typography.button};
`

const SegmentedControlLabel = styled.label<RadioInputLabelProps & { rounded?: boolean }>`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${props => (props.rounded ? props.theme.border.radius.pill : props.theme.border.radius.small)};
  outline-style: none;
  padding: ${({ theme }) => theme.spacing.xxs};
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  ${props => props.theme.motion.standardTransition}
  transition-property: transform, color, opacity;

  ${props => props.theme.selectors.keyboard} &:focus {
    outline-style: auto;
  }

  :hover {
    color: ${props => props.theme.colors.secondaryLabel};
  }

  :active {
    ${props => props.theme.motion.standardActiveState}
  }

  color: ${props => props.theme.colors.label};

  ${props => props.theme.typography.button}

  ${props =>
    props.checked &&
    css`
      background-color: ${props.theme.colors.segmentedControlForeground};
      cursor: default;

      :active,
      :hover {
        color: ${props.theme.colors.label};
      }
    `}

  ${breakpoints.tablet} {
    padding: ${({ theme }) => theme.spacing.s};
  }
`
const StyledLabelComponent = (rounded?: boolean) => (props: RadioInputLabelProps) => (
  <SegmentedControlLabel {...props} rounded={rounded} />
)

export const SegmentedControl = ({
  name,
  options,
  rounded,
  ...radioGroupProps
}: {
  name: string
  options: RadioGroupOption[]
  rounded?: boolean
} & RadioGroupProps) => {
  const optionsWithLabelWrapper = options.map(option => {
    return {
      ...option,
      label: <LabelWrapper>{option.label}</LabelWrapper>,
    }
  })

  return (
    <RadioGroup
      {...radioGroupProps}
      isSegmentedControl
      name={name}
      options={optionsWithLabelWrapper}
      StyledLabelComponent={props => StyledLabelComponent(rounded)(props)}
      rounded={rounded}
    />
  )
}
